import { useCallback } from 'react';
import { capitalizeWord } from '@moda/portal-stanchions';
import { PaymentSource } from '../../constants';
import { GenericError, getNetworkErrors } from '../../lib/error';
import { tc } from '../../lib/trackingContext';

export const useCheckoutErrorTracking = () => {
  const trackCheckoutError = useCallback(
    (paymentSource: PaymentSource | null, error?: GenericError | string | null) => {
      tc.track('Payment Error Encountered', {
        addToTrackingEvent: {
          errorType: `${capitalizeWord(paymentSource)} Payment Error`,
          error: error?.toString() || '',
          errorMessage: getNetworkErrors(error as GenericError)?.[0]?.detail || '',
          label: `${capitalizeWord(paymentSource)} Payment Error`
        }
      });
    },
    []
  );

  return { trackCheckoutError };
};
